import { jsx } from "react/jsx-runtime";
import ApiIcon from "@mui/icons-material/Api";
import { validateTidalLicense } from "../../base/index.js";
function Api(props) {
  return /* @__PURE__ */ jsx(
    ApiIcon,
    {
      "data-testid": "Api",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Api",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
Api.tidalIconMeta = {
  categories: "devices,photos",
  name: "Api"
};
validateTidalLicense();
export {
  Api
};
//# sourceMappingURL=Api.js.map
